export const POPOVER_CSS_CLASSES = {
  POPOVER_ROOT: "popover",
  POPOVER_OPEN: "popover-open",
  POPOVER_ANCHOR: "popover-anchor",
  POPOVER_CONTENT: "popover-content",
};
